import {Base,Axios} from "@/api/Base"

export class OvertimeApplicationExport extends Base {
    path = "overtimeApplication/export"
    download(param = {}) {
        return Axios.get(this.path,{ params: param, responseType: "blob" })
    }
}